var map = {
	"./cat-0.webp": 87920,
	"./cat-1.webp": 36078,
	"./cat-2.webp": 77279,
	"./cat-3.webp": 96999,
	"./cat-4.webp": 30905,
	"./cat-5.webp": 89606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40245;